import { get } from '../utils/get';
import { AppParamsHelper } from '../helpers/AppParamsHelper';
import { IFormatter } from '../models/data/IFormatter';
import formatter from '../utils/formatter';

// This function replaces placeholders enclosed in curley braces with the actual value. For example:
// "http://www.clientwebsitesite.com/fundexplorer/{isin}" -> "http://www.clientwebsitesite.com/fundexplorer/GB1234567890"

export const replacePlaceholders = (replacePlaceholdersOptions: {
	values?: {},
	text: string,
	valueKey?: string,
	appParamsHelper?: AppParamsHelper<any, any, any>,
	format?: IFormatter,
}) => {
	const {
		values,
		valueKey,
		text,
		appParamsHelper,
		format,
	} = replacePlaceholdersOptions;
	if (text) {
		const { type, locale, currency, options } = format || ({} as IFormatter);
		const parsedText = text.replace(/({)[^{]+(})/g, (match) => {
			const key = match.replace('{', '').replace('}', '');

			if (appParamsHelper && appParamsHelper.rawAppParams && key.substring(0, 4).toLowerCase() === 'app:') {
				return appParamsHelper.rawAppParams[key.substring(4, key.length)];
			}

			const value = get(values, `${ key }${ valueKey ? valueKey : '' }`, '');

			return format
				? formatter(type, locale, currency, options, value)
				: value;
		});

		return parsedText;
	}
};
